<template>
  <div>
    <el-table :data="gasList"  size="small" border>
      <!-- <el-table-column prop="id" width="140px" label="ID" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
         
        </template>
      </el-table-column> -->
      <el-table-column prop="coin"  label="币种" fixed>
        <template slot-scope="scope">{{
          scope.row.coin
        }}</template>
      </el-table-column>
      <el-table-column prop="chain"  label="链" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.chain">{{scope.row.chain}}</span>
          <span v-else>--</span>
          
        </template>
      </el-table-column>
      <el-table-column width="180px" prop="state" label="是否主链币" >
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.state==0">否</el-tag>
          <el-tag type="success" v-else>是</el-tag>
        </template></el-table-column>
      <el-table-column width="180px" prop="transferColdValue" label="转冷阀值" >
        <template slot-scope="scope">
          <a >{{scope.row.transferColdValue}}</a>
        </template></el-table-column>
      <el-table-column label="编辑" fixed="right" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button>
          <!-- <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDel(scope.row)"
          ></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="size"
      :total="totalCount"
      :page="page"
      @pageChanged="pageChanged"
    ></pagination>
    <update-dialog  :val="userinfoDetail"  :selected="queryValue" :page="page" :size="size"></update-dialog>
   
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import updateDialog from '../updatedialog';

export default {
  name: 'GasList',
 props:['queryValue'],
  data() {
    return {
      page:1,size:25,
    };
  },
  components: {
    Pagination,
    updateDialog
  },
  methods: {
    ...mapActions('gas', [
      'updateDividendStatus',
      'updateMark'
    ]),
    ...mapMutations('gas', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    pageChanged(e) {
      this.page=e.page
      this.size=e.size
      this.$emit('refresh', {page:this.page,size:this.size});
    },
    handleDel(row){
      console.log(row);
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
   
  },
  computed: {
    ...mapGetters('gas', ['userList',]),
    ...mapState('gas', [
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible','blockInfoList','gasList'
    ])
  }
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
